import React from "react";
import { Skeleton } from "primereact/skeleton";
const LabelSkeleton = () => {
  return (
    <Skeleton width="10rem" className="mb-2" borderRadius="16px"></Skeleton>
  );
};
export default LabelSkeleton;
